import { connect } from 'react-redux';
import EditDrawer from './EditDrawer';
import {
  editCarrierAuthorization,
  fetchCarrierAuthorizationDetails,
  fetchCustomers,
} from '../store/carrierAuthorizationsSlice';

const mapState = state => ({
  customers: state.loadingManagement.carrierAuthorizations.customers,
  details: state.loadingManagement.carrierAuthorizations.carrierAuthorizationDetails,
  isCustomersLoading: state.loadingManagement.carrierAuthorizations.isFetchingCustomers,
  isDetailsLoading:
    state.loadingManagement.carrierAuthorizations.isFetchingCarrierAuthorizationDetails,
});

const mapDispatchToProps = {
  editCarrierAuthorization,
  fetchCarrierAuthorizationDetails,
  fetchCustomers,
};

export default connect(mapState, mapDispatchToProps)(EditDrawer);
